<div class="copilot-message-container" *ngIf="creativesURLs?.length">
  <div class="copilot-message-content">
    <div class="creatives-grid" *ngIf="creativesURLs?.length">
      <div class="creative-item" *ngFor="let url of creativesURLs; let i = index;">
        <div class="creative-card" (click)="openCreative(url)">
          <div class="image-frame">
            <img [src]="url" alt="Creative">
          </div>
        </div>
        <div class="creative-caption">Creative {{ 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[i] }}</div>
      </div>
    </div>
  </div>
</div>
